<template>
  <div class="p-itemArea__sortingButtonsGroup">
    <v-btn
      small
      tile
      style="border: 1px solid #c4c4c4"
      :disabled="editingItemIndex != null"
      @click="swapForUnderItem"
    >
      <v-icon> mdi-arrow-down </v-icon>
    </v-btn>
    <v-btn
      small
      tile
      style="border: 1px solid #c4c4c4"
      :disabled="editingItemIndex != null"
      @click="swapForUpperItem"
    >
      <v-icon> mdi-arrow-up </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SortingButtonsGroup',
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      contentFieldElement: null,
      fieldMarginTop: 20,
      listItemClassName: 'p-itemList__item',
      postEditorContentFieldID: 'p-postEditor__content-field'
    }
  },
  computed: {
    sortableItems: {
      get () {
        return this.$store.state.PostEditor.post.items
      },
      set (items) {
        this.$store.commit('PostEditor/SORT_ITEMS', items)
      }
    },
    ...mapState({
      editingItemIndex: (state) => state.PostEditor.editingItemIndex
    })
  },
  mounted () {
    this.contentFieldElement = document.getElementById(
      this.postEditorContentFieldID
    )
  },
  methods: {
    swapForUpperItem () {
      if (this.index <= 0) return

      const cloneItems = [...this.sortableItems]
      cloneItems[this.index] = this.sortableItems[this.index - 1]
      cloneItems[this.index - 1] = this.sortableItems[this.index]

      this.scrollToUpperItem()
      this.sortableItems = cloneItems
    },
    swapForUnderItem () {
      if (this.index < 0 || this.index >= this.sortableItems.length - 1) return

      const cloneItems = [...this.sortableItems]
      cloneItems[this.index] = this.sortableItems[this.index + 1]
      cloneItems[this.index + 1] = this.sortableItems[this.index]

      this.scrollToUnderItem()
      this.sortableItems = cloneItems
    },
    scrollToUpperItem () {
      const top =
        this.contentFieldElement.scrollTop -
        document
          .getElementsByClassName(this.listItemClassName)[this.index - 1]
          .getBoundingClientRect()['height'] -
        this.fieldMarginTop

      this.scrollOnContent(top)
    },
    scrollToUnderItem () {
      const top =
        this.contentFieldElement.scrollTop +
        document
          .getElementsByClassName(this.listItemClassName)[this.index + 1]
          .getBoundingClientRect()['height'] +
        this.fieldMarginTop

      this.scrollOnContent(top)
    },
    scrollOnContent (top) {
      this.contentFieldElement.scrollTo({
        top: top,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style>
.p-itemArea__sortingButtonsGroup {
  padding: 5px;
  display: flex;
  flex-wrap: wrap;
}
</style>
